// GasCalculator.js

import React, { useState, useEffect } from "react";
import axios from "axios";

function GasCalculator() {
  const [cadPerLiter, setCadPerLiter] = useState("");
  const [usdPerGallon, setUsdPerGallon] = useState("");
  const [rate, setRate] = useState(null);
  const [primaryCurrency, setPrimaryCurrency] = useState("CAD");
  const [cadCashback, setCadCashback] = useState(0);
  const [usdCashback, setUsdCashback] = useState(0);
  const [tankLitres, setTankLitres] = useState(0);
  const [showComingSoon, setShowComingSoon] = useState(false);

  useEffect(() => {
    const fetchRate = async () => {
      try {
        const response = await axios.get(
          "https://api.frankfurter.app/latest?from=USD&to=CAD",
        );
        setRate(response.data.rates.CAD);
      } catch (error) {
        console.error("Error fetching rate:", error);
      }
    };
    fetchRate();
    if (window.gtag && window.consented)
      window.gtag("event", "tool_view", { tool: "gas" });

    // Load preferences
    setPrimaryCurrency(localStorage.getItem("primaryCurrency") || "CAD");
    setCadCashback(parseFloat(localStorage.getItem("cadCashback")) || 0);
    setUsdCashback(parseFloat(localStorage.getItem("usdCashback")) || 0);
    setTankLitres(parseFloat(localStorage.getItem("tankLitres")) || 0);
  }, []);

  const convertCadToUsd = (cad) => {
    if (cad && rate) {
      const usdPerLiter = cad / rate;
      const usdPerGallon = usdPerLiter * 3.78541;
      setUsdPerGallon(usdPerGallon.toFixed(2));
    }
  };

  const convertUsdToCad = (usd) => {
    if (usd && rate) {
      const usdPerLiter = usd / 3.78541;
      const cadPerLiter = usdPerLiter * rate;
      setCadPerLiter(cadPerLiter.toFixed(2));
    }
  };

  const handleClick = () => {
    setShowComingSoon(true);
    setTimeout(() => setShowComingSoon(false), 3000); // Hide after 3 seconds
    if (window.gtag && window.consented)
      window.gtag("event", "gas_price_fetch_click", { status: "coming_soon" });
  };

  return (
    <section
      className="utility canada-theme us-theme"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <h2>
        Gas Price Calc{" "}
        <span style={{ fontSize: "0.8em", opacity: 0.7 }}>
          (Click to get prices)
        </span>
      </h2>
      {showComingSoon && (
        <div
          style={{
            backgroundColor: "rgba(255, 165, 0, 0.1)",
            border: "1px solid orange",
            padding: "10px",
            borderRadius: "4px",
            marginBottom: "10px",
            textAlign: "center",
            fontWeight: "bold",
            color: "orange",
          }}
        >
          🚗 Gas price fetching coming soon! 🚗
        </div>
      )}
      <div className="conversion-row">
        <div className="left">
          <label>$CAD / L</label>
          <input
            type="number"
            step="0.01"
            value={cadPerLiter}
            onChange={(e) => {
              setCadPerLiter(e.target.value);
              convertCadToUsd(e.target.value);
            }}
            className="tall-input"
          />
        </div>
        <div className="right">
          <label>$USD / gal</label>
          <input
            type="number"
            step="0.01"
            value={usdPerGallon}
            onChange={(e) => {
              setUsdPerGallon(e.target.value);
              convertUsdToCad(e.target.value);
            }}
            className="tall-input"
          />
        </div>
      </div>
      {cadPerLiter && usdPerGallon && rate && tankLitres > 0 && (
        <div className="fill-up-cost">
          {(() => {
            const tankGallons = tankLitres / 3.78541;
            const costCAD =
              parseFloat(cadPerLiter) * tankLitres * (1 - cadCashback / 100);
            const costUSD =
              parseFloat(usdPerGallon) * tankGallons * (1 - usdCashback / 100);
            const costUSD_in_CAD = costUSD * rate;
            let cheapestCost, location, otherCost, otherLocation;
            if (costCAD < costUSD_in_CAD) {
              cheapestCost = costCAD;
              location = "Canada";
              otherCost = costUSD_in_CAD;
              otherLocation = "US";
            } else {
              cheapestCost = costUSD_in_CAD;
              location = "US";
              otherCost = costCAD;
              otherLocation = "Canada";
            }
            if (primaryCurrency === "USD") {
              cheapestCost = cheapestCost / rate;
              otherCost = otherCost / rate;
            }
            return (
              <>
                <div>
                  ${cheapestCost.toFixed(2)} {primaryCurrency} to fill up in{" "}
                  {location}
                </div>
                <div>
                  ${otherCost.toFixed(2)} {primaryCurrency} to fill up in{" "}
                  {otherLocation}
                </div>
              </>
            );
          })()}
        </div>
      )}
    </section>
  );
}

export default GasCalculator;
